import { formatMonetaryValue, getCurrencySymbolByCurrency } from "../../../Utils/formatters";
import intl from "react-intl-universal";

export const CONTA_INTERNACIONAL_HOME_PATH = "/conta-internacional";

export const CURRENCIES = [
  {
    id: "usd", label: "Dólar americano", code: "USD", balance: 4250.8, blockedBalance: 250, limit: 15000,
    rateToBrl: 5.1623, isPrimary: true,
  },
  {
    id: "eur", label: "Euro", code: "EUR", balance: 1875.45, blockedBalance: 0, limit: 10000,
    rateToBrl: 5.9841, isPrimary: true,
  },
  {
    id: "pyg", label: "Guaraní paraguaio", code: "PYG", balance: 4850000, blockedBalance: 250000, limit: 50000000,
    rateToBrl: 0.00075, isPrimary: true,
  },
  {
    id: "brl", label: "Real brasileiro", code: "BRL", balance: 12500.0, blockedBalance: 500, limit: 50000,
    rateToBrl: 1, isPrimary: false,
  },
  {
    id: "cad", label: "Dólar canadense", code: "CAD", balance: 3100.0, blockedBalance: 0, limit: 8000,
    rateToBrl: 3.7854, isPrimary: true,
  },
  {
    id: "chf", label: "Franco suíço", code: "CHF", balance: 1580.25, blockedBalance: 50, limit: 6000,
    rateToBrl: 6.4218, isPrimary: false,
  },
  {
    id: "jpy", label: "Iene japonês", code: "JPY", balance: 450000, blockedBalance: 0, limit: 2000000,
    rateToBrl: 0.0342, isPrimary: false,
  },
  {
    id: "aud", label: "Dólar australiano", code: "AUD", balance: 2760.5, blockedBalance: 0, limit: 7000,
    rateToBrl: 3.4127, isPrimary: false,
  },
  {
    id: "mxn", label: "Peso mexicano", code: "MXN", balance: 18500.0, blockedBalance: 1200, limit: 100000,
    rateToBrl: 0.2984, isPrimary: false,
  },
  {
    id: "sek", label: "Coroa sueca", code: "SEK", balance: 12400.0, blockedBalance: 0, limit: 80000,
    rateToBrl: 0.5126, isPrimary: false,
  },
];

export const getPrimaryCurrencies = () => CURRENCIES.filter((c) => c.isPrimary);

export const DEFAULT_CURRENCY_ID = CURRENCIES[0].id;

export const contaInternacionalCurrencyPath = (currencyId) =>
  `/conta-internacional/${currencyId}`;

export const contaInternacionalDepositarPath = (currencyId = DEFAULT_CURRENCY_ID) =>
  `/conta-internacional/${currencyId}/depositar`;

export const contaInternacionalMovimentarPath = (currencyId = DEFAULT_CURRENCY_ID) =>
  `/conta-internacional/${currencyId}/movimentar`;

export const contaInternacionalTransferirPath = (currencyId = DEFAULT_CURRENCY_ID) =>
  `/conta-internacional/${currencyId}/transferir`;

export const BASE_FX_QUOTES = [
  { id: "usd-brl", asset: "usd", pair: "USD / BRL", baseRate: 5.1623, change: "+0,35%", positive: true },
  { id: "eur-brl", asset: "eur", pair: "EUR / BRL", baseRate: 5.9841, change: "+0,22%", positive: true },
  { id: "pyg-brl", asset: "pyg", pair: "PYG / BRL", baseRate: 0.00075, change: "+0,15%", positive: true },
  { id: "jpy-brl", asset: "jpy", pair: "JPY / BRL", baseRate: 0.0342, change: "+0,18%", positive: true },
  { id: "usd-eur", asset: "usd", pair: "USD / EUR", baseRate: 0.8632, change: "+0,08%", positive: true },
  { id: "usdc-usd", asset: "usdc", pair: "USDC / USD", baseRate: 0.9998, change: "+0,01%", positive: true },
];

export const JURISDICTION = {
  country: "BR",
  countryLabel: "Brasil",
  availableTransferMethods: ["pix", "wire", "ach", "sepa", "swift"],
};

export const TRANSFER_WIZARD_STEPS = [
  { id: 0, label: "Conta e valor", description: "Moeda, meio e valor" },
  { id: 1, label: "Destinatário", description: "Dados do beneficiário" },
  { id: 2, label: "Resumo", description: "Revise e confirme" },
];

export const TRANSFER_METHODS = {
  pix: { id: "pix", label: "Pix", description: "Transferência instantânea em BRL" },
  wire: { id: "wire", label: "Wire", description: "Transferência bancária internacional (Wire)" },
  ach: { id: "ach", label: "ACH", description: "Transferência eletrônica nos EUA" },
  sepa: { id: "sepa", label: "SEPA", description: "Transferência na zona euro" },
  swift: { id: "swift", label: "SWIFT", description: "Transferência internacional" },
};

export const ACCOUNT_DATA_FIELD_LABELS = {
  bankName: "Nome do banco",
  accountNumber: "Número da conta",
  iban: "IBAN",
  swiftBic: "SWIFT / BIC",
  routingNumber: "Routing (ABA)",
  sortCode: "Sort code",
  branch: "Agência",
  pixKey: "Chave Pix",
  pixKeyType: "Tipo de chave",
  beneficiary: "Beneficiário",
  beneficiaryAddress: "Endereço do beneficiário",
  referenceInstructions: "Instruções de referência",
};

export const CURRENCY_ACCOUNT_DATA_RAILS = {
  usd: ["wire", "ach", "swift"],
  eur: ["sepa", "swift"],
  pyg: ["swift"],
  brl: ["pix"],
  cad: ["swift"],
  chf: ["swift"],
  jpy: ["swift"],
  aud: ["swift"],
  mxn: ["swift"],
  sek: ["swift"],
};

export const ACCOUNT_BANKING_DETAILS = {
  usd: {
    wire: {
      bankName: "Valut Bank N.A.",
      accountNumber: "8847291034",
      routingNumber: "021000089",
      beneficiary: "Valut Pagamentos Ltda.",
      beneficiaryAddress: "Av. Paulista, 1000 — São Paulo, SP — Brasil",
      referenceInstructions: "Inclua seu ID de cliente (VAL-884729) na descrição da transferência.",
    },
    ach: {
      bankName: "Valut Bank N.A.",
      accountNumber: "8847291034",
      routingNumber: "026009593",
      beneficiary: "Valut Pagamentos Ltda.",
      referenceInstructions: "Use apenas para transferências domésticas nos EUA. Referência: VAL-884729.",
    },
    swift: {
      bankName: "Valut Bank N.A.",
      swiftBic: "VLUTUS33XXX",
      accountNumber: "8847291034",
      iban: "US33VLUT00260298847291034",
      beneficiary: "Valut Pagamentos Ltda.",
      beneficiaryAddress: "Av. Paulista, 1000 — São Paulo, SP — Brasil",
      referenceInstructions: "Transferências SWIFT podem levar de 1 a 3 dias úteis. Referência: VAL-884729.",
    },
  },
  eur: {
    sepa: {
      bankName: "Valut Europe S.A.",
      iban: "DE89370400440532013000",
      swiftBic: "COBADEFFXXX",
      beneficiary: "Valut Pagamentos Europe",
      referenceInstructions: "Transferências SEPA são processadas em até 1 dia útil. Referência: VAL-EU-884729.",
    },
    swift: {
      bankName: "Valut Europe S.A.",
      swiftBic: "VLUTEU33XXX",
      iban: "DE89370400440532013000",
      beneficiary: "Valut Pagamentos Europe",
      beneficiaryAddress: "Frankfurt am Main, Alemanha",
      referenceInstructions: "Para transferências fora da zona SEPA. Referência: VAL-EU-884729.",
    },
  },
  pyg: {
    swift: {
      bankName: "Banco Valut Paraguay S.A.",
      swiftBic: "VLUTPYPA",
      accountNumber: "8847291034",
      beneficiary: "Valut Pagamentos Paraguay",
      beneficiaryAddress: "Asunción, Paraguai",
      referenceInstructions: "Transferências internacionais via SWIFT. Referência: VAL-PY-884729.",
    },
  },
  brl: {
    pix: {
      bankName: "Banco Valut S.A.",
      branch: "0001",
      accountNumber: "123456-7",
      pixKey: "contato@valut.com.br",
      pixKeyType: "E-mail",
      beneficiary: "Valut Pagamentos Ltda.",
      referenceInstructions: "Depósitos via Pix são creditados em poucos minutos.",
    },
  },
};

export const DEPOSIT_METHODS = {
  wire: { id: "wire", label: "Depósito bancário (Wire)", description: "Transferência bancária nos EUA" },
  sepa: { id: "sepa", label: "Depósito SEPA", description: "Transferência na zona euro" },
  swift: { id: "swift", label: "Depósito SWIFT", description: "Transferência internacional" },
  pix: { id: "pix", label: "Depósito via Pix", description: "Transferência instantânea em BRL" },
};

export const CURRENCY_DEPOSIT_METHODS = {
  usd: ["wire", "swift"],
  eur: ["sepa", "swift"],
  pyg: ["swift"],
  brl: ["pix", "wire"],
  cad: ["swift"],
  chf: ["swift"],
  jpy: ["swift"],
  aud: ["swift"],
  mxn: ["swift"],
  sek: ["swift"],
};

export const CURRENCY_TRANSFER_METHODS = {
  usd: ["wire", "ach", "swift"],
  eur: ["sepa", "swift"],
  pyg: ["swift"],
  brl: ["pix", "wire", "swift"],
  cad: ["swift"],
  chf: ["swift"],
  jpy: ["swift"],
  aud: ["swift"],
  mxn: ["swift"],
  sek: ["swift"],
};

export const getMovementKindMeta = () => ({
  deposit: { label: intl.get("contaInternacional.typeDeposit"), badgeClass: "bg-emerald-50 text-emerald-700" },
  transfer: { label: intl.get("contaInternacional.typeTransfer"), badgeClass: "bg-sky-50 text-sky-700" },
  swap: { label: intl.get("contaInternacional.typeConversion"), badgeClass: "bg-violet-50 text-violet-700" },
  internal: { label: intl.get("contaInternacional.typeInternal"), badgeClass: "bg-amber-50 text-amber-700" },
});

/** @deprecated Use getMovementKindMeta() at render time for i18n */
export const MOVEMENT_KIND_META = {
  deposit: { label: "Depósito", badgeClass: "bg-emerald-50 text-emerald-700" },
  transfer: { label: "Transferência", badgeClass: "bg-sky-50 text-sky-700" },
  swap: { label: "Conversão", badgeClass: "bg-violet-50 text-violet-700" },
  internal: { label: "Movimentação", badgeClass: "bg-amber-50 text-amber-700" },
};

export const getHistoryTabs = () => [
  { id: "purchases", label: intl.get("contaInternacional.tabPurchases") },
  { id: "withdrawals", label: intl.get("contaInternacional.tabWithdrawals") },
  { id: "transfers", label: intl.get("contaInternacional.tabTransfers") },
  { id: "conversions", label: intl.get("contaInternacional.tabConversions") },
];

/** @deprecated Use getHistoryTabs() at render time for i18n */
export const HISTORY_TABS = [
  { id: "purchases", label: "Compras" },
  { id: "withdrawals", label: "Saques" },
  { id: "transfers", label: "Envios" },
  { id: "conversions", label: "Conversões" },
];

export const getGeneralHistoryTabs = () => [
  { id: "all", label: intl.get("common.all") },
  ...getHistoryTabs(),
];

/** @deprecated Use getGeneralHistoryTabs() at render time for i18n */
export const GENERAL_HISTORY_TABS = [
  { id: "all", label: "Todos" },
  ...HISTORY_TABS,
];

export const getHistoryKindMeta = () => ({
  purchases: { label: intl.get("contaInternacional.typePurchase"), badgeClass: "bg-sky-50 text-sky-700" },
  withdrawals: { label: intl.get("contaInternacional.typeWithdrawal"), badgeClass: "bg-gray-100 text-gray-700" },
  transfers: { label: intl.get("contaInternacional.typeTransfer"), badgeClass: "bg-amber-50 text-amber-700" },
  conversions: { label: intl.get("contaInternacional.typeConversion"), badgeClass: "bg-violet-50 text-violet-700" },
});

/** @deprecated Use getHistoryKindMeta() at render time for i18n */
export const HISTORY_KIND_META = {
  purchases: { label: "Compra", badgeClass: "bg-sky-50 text-sky-700" },
  withdrawals: { label: "Saque", badgeClass: "bg-gray-100 text-gray-700" },
  transfers: { label: "Envio", badgeClass: "bg-amber-50 text-amber-700" },
  conversions: { label: "Conversão", badgeClass: "bg-violet-50 text-violet-700" },
};

const parseHistoryDate = (dateStr) => {
  const [datePart, timePart = "00:00"] = dateStr.split(" ");
  const [day, month, year] = datePart.split("/").map(Number);
  const [hours, minutes] = timePart.split(":").map(Number);
  return new Date(year, month - 1, day, hours, minutes);
};

export const MOCK_PURCHASES = [
  {
    id: "ci-p1", date: "17/06/2026 09:15", asset: "usd", amount: 1500, amountBrl: 7743.45, rate: 5.1623, status: "Concluída",
    method: "Wire (ACH)",
  },
  {
    id: "ci-p2", date: "14/06/2026 11:40", asset: "eur", amount: 800, amountBrl: 4787.28, rate: 5.9841, status: "Concluída",
    method: "SEPA",
  },
  {
    id: "ci-p3", date: "10/06/2026 16:22", asset: "pyg", amount: 500000, amountBrl: 375.0, rate: 0.00075, status: "Concluída",
    method: "SWIFT",
  },
];

export const MOCK_WITHDRAWALS = [
  {
    id: "ci-w1", date: "16/06/2026 14:32", asset: "usd", amount: 500, destination: "Conta bancária ••••4521", status: "Concluído",
    method: "Wire (ACH)",
  },
  {
    id: "ci-w2", date: "12/06/2026 10:08", asset: "eur", amount: 200, destination: "Conta bancária ••••8834", status: "Concluído",
    method: "SEPA",
  },
  {
    id: "ci-w3", date: "08/06/2026 08:30", asset: "usd", amount: 3000, destination: "Conta bancária ••••1290", status: "Em processamento",
    method: "SWIFT",
  },
];

export const MOCK_TRANSFERS = [
  {
    id: "ci-t1", date: "15/06/2026 11:08", asset: "usd", amount: 200, recipient: "John Smith ••••9012", status: "Concluído",
    method: "SWIFT",
  },
  {
    id: "ci-t2", date: "13/06/2026 17:00", asset: "eur", amount: 150, recipient: "Maria Garcia ••••3344", status: "Concluído",
    method: "SEPA",
  },
  {
    id: "ci-t3", date: "09/06/2026 09:40", asset: "brl", amount: 500, recipient: "Fornecedor ABC Ltda.", status: "Concluído",
    method: "Pix",
  },
];

export const MOCK_CONVERSIONS = [
  {
    id: "ci-c1", date: "16/06/2026 14:32", from: "usd", to: "brl", amountFrom: 500, amountTo: 2576.15, rate: 5.1523, status: "Concluída",
  },
  {
    id: "ci-c2", date: "13/06/2026 10:22", from: "eur", to: "usd", amountFrom: 461.5, amountTo: 500, rate: 1.0834, status: "Concluída",
  },
  {
    id: "ci-c3", date: "08/06/2026 15:55", from: "brl", to: "usd", amountFrom: 1000, amountTo: 193.7, rate: 0.1937, status: "Concluída",
  },
  {
    id: "ci-c4", date: "05/06/2026 12:10", from: "pyg", to: "eur", amountFrom: 100000, amountTo: 12.85, rate: 0.0001285, status: "Concluída",
  },
];

export const getAllContaInternacionalHistory = () =>
  [
    ...MOCK_PURCHASES.map((item) => ({ ...item, historyKind: "purchases" })),
    ...MOCK_WITHDRAWALS.map((item) => ({ ...item, historyKind: "withdrawals" })),
    ...MOCK_TRANSFERS.map((item) => ({ ...item, historyKind: "transfers" })),
    ...MOCK_CONVERSIONS.map((item) => ({ ...item, historyKind: "conversions" })),
  ].sort((a, b) => parseHistoryDate(b.date) - parseHistoryDate(a.date));

export const MOCK_MOVEMENTS = [
  {
    id: "m1", date: "17/06/2026 09:15", currency: "usd", kind: "deposit",
    amount: 1500, description: "Depósito via Wire", status: "Concluída",
  },
  {
    id: "m2", date: "16/06/2026 14:32", currency: "usd", kind: "swap",
    amount: -500, description: "Conversão USD → EUR", status: "Concluída",
    counterCurrency: "eur", counterAmount: 461.5,
  },
  {
    id: "m3", date: "15/06/2026 11:08", currency: "usd", kind: "transfer",
    amount: -200, description: "SWIFT para conta externa", status: "Concluída",
  },
  {
    id: "m4", date: "14/06/2026 16:45", currency: "eur", kind: "deposit",
    amount: 800, description: "Depósito via SEPA", status: "Concluída",
  },
  {
    id: "m5", date: "13/06/2026 10:22", currency: "eur", kind: "swap",
    amount: 461.5, description: "Conversão USD → EUR", status: "Concluída",
    counterCurrency: "usd", counterAmount: -500,
  },
  {
    id: "m6", date: "12/06/2026 08:30", currency: "eur", kind: "transfer",
    amount: -150, description: "SEPA para fornecedor", status: "Concluída",
  },
  {
    id: "m7", date: "11/06/2026 17:00", currency: "pyg", kind: "deposit",
    amount: 500, description: "Depósito via SWIFT", status: "Concluída",
  },
  {
    id: "m8", date: "10/06/2026 13:15", currency: "pyg", kind: "internal",
    amount: -100, description: "Movimentação para conta USD", status: "Concluída",
    counterCurrency: "usd", counterAmount: 126.5,
  },
  {
    id: "m9", date: "09/06/2026 09:40", currency: "brl", kind: "deposit",
    amount: 3000, description: "Depósito via Pix", status: "Concluída",
  },
  {
    id: "m10", date: "08/06/2026 15:55", currency: "brl", kind: "swap",
    amount: -1000, description: "Conversão BRL → USD", status: "Concluída",
    counterCurrency: "usd", counterAmount: 193.7,
  },
  {
    id: "m11", date: "07/06/2026 12:10", currency: "brl", kind: "transfer",
    amount: -500, description: "Pix para terceiro", status: "Concluída",
  },
];

export const CONVERSION_FEE_PERCENT = 0.35;
export const IOF_PERCENT = 0.38;
export const MOVEMENT_FEE_PERCENT = 0.15;

export const TRANSFER_METHOD_FEES = {
  pix: { label: "Taxa Pix", type: "flat", amount: 0 },
  wire: { label: "Taxa Wire", type: "flat", amount: 25 },
  ach: { label: "Taxa ACH", type: "flat", amount: 5 },
  sepa: { label: "Taxa SEPA", type: "flat", amount: 0.5 },
  swift: { label: "Taxa SWIFT", type: "percent", amount: 0.5 },
};

export const TRANSFER_BENEFICIARY_FIELD_DEFS = {
  beneficiaryName: {
    key: "beneficiaryName",
    label: "Nome do beneficiário",
    placeholder: "Nome completo",
    inputType: "text",
  },
  bankName: {
    key: "bankName",
    label: "Nome do banco",
    placeholder: "Nome do banco recebedor",
    inputType: "text",
  },
  swiftBic: {
    key: "swiftBic",
    label: "Código SWIFT / BIC",
    placeholder: "Ex.: VLUTUS33XXX",
    inputType: "text",
  },
  iban: {
    key: "iban",
    label: "IBAN",
    placeholder: "Ex.: DE89370400440532013000",
    inputType: "text",
  },
  accountNumber: {
    key: "accountNumber",
    label: "Número da conta",
    placeholder: "Número da conta",
    inputType: "text",
  },
  routingNumber: {
    key: "routingNumber",
    label: "Routing number (ABA)",
    placeholder: "Ex.: 021000089",
    inputType: "text",
  },
  accountType: {
    key: "accountType",
    label: "Tipo de conta",
    inputType: "select",
    placeholder: "Selecione o tipo",
    options: [
      { value: "checking", label: "Corrente (Checking)" },
      { value: "savings", label: "Poupança (Savings)" },
    ],
  },
  reference: {
    key: "reference",
    label: "Referência",
    placeholder: "Referência ou descrição",
    inputType: "text",
  },
  pixKey: {
    key: "pixKey",
    label: "Chave Pix",
    placeholder: "CPF, e-mail, telefone ou chave aleatória",
    inputType: "text",
  },
  pixKeyType: {
    key: "pixKeyType",
    label: "Tipo de chave Pix",
    inputType: "select",
    placeholder: "Selecione o tipo",
    options: [
      { value: "cpf", label: "CPF" },
      { value: "email", label: "E-mail" },
      { value: "phone", label: "Telefone" },
      { value: "random", label: "Chave aleatória" },
    ],
  },
};

export const TRANSFER_RAIL_BENEFICIARY_FIELDS = {
  swift: [
    { key: "beneficiaryName", required: true },
    { key: "swiftBic", required: true },
    { key: "iban", required: true },
    { key: "accountNumber", required: true },
    { key: "bankName", required: true },
    { key: "reference", required: false },
  ],
  wire: [
    { key: "beneficiaryName", required: true },
    { key: "routingNumber", required: true },
    { key: "accountNumber", required: true },
    { key: "bankName", required: true },
  ],
  ach: [
    { key: "beneficiaryName", required: true },
    { key: "routingNumber", required: true },
    { key: "accountNumber", required: true },
    { key: "accountType", required: true },
  ],
  sepa: [
    { key: "beneficiaryName", required: true },
    { key: "iban", required: true },
    { key: "swiftBic", required: false },
    { key: "reference", required: false },
  ],
  pix: [
    { key: "beneficiaryName", required: true },
    { key: "pixKeyType", required: true },
    { key: "pixKey", required: true },
  ],
};

export const getTransferBeneficiaryFields = (railId) => {
  const fields = TRANSFER_RAIL_BENEFICIARY_FIELDS[railId] ?? [];
  return fields
    .map(({ key, required }) => {
      const def = TRANSFER_BENEFICIARY_FIELD_DEFS[key];
      if (!def) return null;
      return { ...def, required };
    })
    .filter(Boolean);
};

export const formatTransferBeneficiaryFieldValue = (field, value) => {
  if (!value) return "";
  if (field.inputType !== "select") return value;
  return field.options?.find((option) => option.value === value)?.label ?? value;
};

export const getTransferBeneficiarySummaryLines = (railId, values = {}) => {
  const fields = getTransferBeneficiaryFields(railId);
  return fields
    .filter((field) => values[field.key])
    .map((field) => ({
      label: field.label,
      value: formatTransferBeneficiaryFieldValue(field, values[field.key]),
    }));
};

export const formatPercent = (value) =>
  `${new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)}%`;

export const getCurrency = (id) => CURRENCIES.find((c) => c.id === id);

export const getMovementsByCurrency = (currencyId) =>
  MOCK_MOVEMENTS.filter((m) => m.currency === currencyId);

export const getAvailableTransferMethods = (currencyId) => {
  const methodIds = CURRENCY_TRANSFER_METHODS[currencyId] || [];
  return methodIds
    .map((id) => TRANSFER_METHODS[id])
    .filter((method) => JURISDICTION.availableTransferMethods.includes(method.id));
};

export const getAvailableDepositMethods = (currencyId) => {
  const methodIds = CURRENCY_DEPOSIT_METHODS[currencyId] || [];
  return methodIds
    .map((id) => DEPOSIT_METHODS[id])
    .filter((method) => JURISDICTION.availableTransferMethods.includes(method.id));
};

export const getAccountDataRails = (currencyId) => {
  const railIds = CURRENCY_ACCOUNT_DATA_RAILS[currencyId] || [];
  return railIds
    .map((id) => TRANSFER_METHODS[id])
    .filter(Boolean);
};

export const getAccountBankingDetails = (currencyId, railId) =>
  ACCOUNT_BANKING_DETAILS[currencyId]?.[railId] ?? null;

export const formatBrl = (value) => formatMonetaryValue(value, "BRL");

const resolveCurrencyCode = (currencyId) => {
  const currency = getCurrency(currencyId);
  return currency?.code || String(currencyId || "").toUpperCase();
};

export const getCurrencySymbol = (currencyId) => {
  const code = resolveCurrencyCode(currencyId);
  return getCurrencySymbolByCurrency(code);
};

export const formatCurrencyWithSymbol = (value, currencyId) => {
  const code = resolveCurrencyCode(currencyId);
  return formatMonetaryValue(value, code);
};

export const formatCrossborderAmount = formatCurrencyWithSymbol;
export const getCrossborderCurrencySymbol = getCurrencySymbol;

export const formatCurrencyAmount = formatCurrencyWithSymbol;

export const getCiStatusLabel = (status) => {
  const value = String(status || "").toLowerCase();
  if (value.includes("process")) return intl.get("contaInternacional.statusProcessing");
  return intl.get("contaInternacional.statusCompleted");
};

export const formatCiPurchaseHistoryTitle = (item) =>
  intl.get("contaInternacional.historyPurchaseTitle", {
    amount: formatCurrencyAmount(item.amount, item.asset),
  });

export const formatCiPurchaseHistoryDetail = (item) => {
  const quote = intl.get("stables.quoteRate", { rate: formatBrl(item.rate) });
  return item.method ? `${quote} • ${item.method}` : quote;
};

export const formatCiWithdrawalHistoryTitle = (item) =>
  intl.get("contaInternacional.historyWithdrawalTitle", {
    amount: formatCurrencyAmount(item.amount, item.asset),
  });

const resolveCiWithdrawalMethodId = (method = "") => {
  const lower = String(method).toLowerCase();
  if (lower.includes("pix")) return "pix";
  if (lower.includes("sepa")) return "sepa";
  if (lower.includes("swift")) return "swift";
  if (lower.includes("ach")) return "ach";
  if (lower.includes("wire")) return "wire";
  return null;
};

export const resolveCiWithdrawalFee = (item) => {
  if (item?.fee != null) return Number(item.fee) || 0;
  const methodId = resolveCiWithdrawalMethodId(item?.method);
  const quote = getTransferQuote({
    currencyId: item?.asset,
    methodId,
    amount: item?.amount,
  });
  return quote.fee;
};

export const formatCiWithdrawalHistoryAmount = (item) =>
  formatCurrencyAmount(item.amount, item.asset);

export const formatCiWithdrawalHistoryFeeDetail = (item) =>
  intl.get("stables.feeAmount", {
    amount: formatCurrencyAmount(resolveCiWithdrawalFee(item), item.asset),
  });

export const formatCiTransferHistoryTitle = (item) =>
  intl.get("contaInternacional.historyTransferTitle", {
    amount: formatCurrencyAmount(item.amount, item.asset),
  });

export const formatCiConversionHistoryTitle = (item) =>
  intl.get("stables.historySwapTitle", {
    from: item.from.toUpperCase(),
    to: item.to.toUpperCase(),
  });

export const formatCiSentAmountDetail = (item) =>
  intl.get("stables.sentAmount", {
    amount: formatCurrencyAmount(item.amountFrom, item.from),
  });

export const formatFxRate = (value) =>
  new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(value);

export const getTotalBalanceBrl = () =>
  CURRENCIES.reduce((sum, c) => sum + c.balance * c.rateToBrl, 0);

export const getMockFxRate = (fromId, toId) => {
  if (fromId === toId) return 1;

  const from = getCurrency(fromId);
  const to = getCurrency(toId);
  if (!from || !to) return 0;

  const directQuote = BASE_FX_QUOTES.find((quote) => {
    const [baseCode, quoteCode] = quote.pair.split(" / ");
    return baseCode === from.code && quoteCode === to.code;
  });
  if (directQuote) return directQuote.baseRate;

  const inverseQuote = BASE_FX_QUOTES.find((quote) => {
    const [baseCode, quoteCode] = quote.pair.split(" / ");
    return baseCode === to.code && quoteCode === from.code;
  });
  if (inverseQuote) return 1 / inverseQuote.baseRate;

  return from.rateToBrl / to.rateToBrl;
};

export const computeConversion = ({ fromId, toId, amount }) => {
  const from = getCurrency(fromId);
  const to = getCurrency(toId);
  if (!from || !to || !amount) {
    return { rate: 0, grossReceive: 0, fee: 0, netReceive: 0, from, to };
  }

  const rate = getMockFxRate(fromId, toId);
  const grossReceive = amount * rate;
  const fee = grossReceive * (CONVERSION_FEE_PERCENT / 100);
  const netReceive = grossReceive - fee;

  return { rate, grossReceive, fee, netReceive, from, to };
};

export const getMovementQuote = (amount) => {
  const numericAmount = Number(amount) || 0;
  const hasAmount = numericAmount > 0;

  if (!hasAmount) {
    return {
      hasAmount: false,
      fee: 0,
      feePercent: MOVEMENT_FEE_PERCENT,
      netAmount: 0,
    };
  }

  const fee = numericAmount * (MOVEMENT_FEE_PERCENT / 100);

  return {
    hasAmount: true,
    fee,
    feePercent: MOVEMENT_FEE_PERCENT,
    netAmount: numericAmount - fee,
  };
};

export const DEPOSIT_INSTRUCTION_PREVIEW_FIELDS = [
  "bankName",
  "iban",
  "accountNumber",
  "pixKey",
  "swiftBic",
  "referenceInstructions",
];

export const getDepositInstructionsPreview = (currencyId, methodId) => {
  const details = getAccountBankingDetails(currencyId, methodId);
  if (!details) return [];

  return DEPOSIT_INSTRUCTION_PREVIEW_FIELDS.filter((key) => details[key]).map((key) => ({
    label: ACCOUNT_DATA_FIELD_LABELS[key],
    value: details[key],
  }));
};

export const getDepositQuote = ({ methodId, amount }) => {
  const feeConfig = TRANSFER_METHOD_FEES[methodId];
  const numericAmount = Number(amount) || 0;
  const hasAmount = numericAmount > 0 && Boolean(methodId);

  if (!hasAmount) {
    return {
      hasAmount: false,
      fee: 0,
      feeLabel: feeConfig?.label ?? "Taxa do meio",
      feePercent: feeConfig?.type === "percent" ? feeConfig.amount : null,
      netCredit: 0,
    };
  }

  let fee = 0;
  if (feeConfig) {
    fee =
      feeConfig.type === "percent"
        ? numericAmount * (feeConfig.amount / 100)
        : feeConfig.amount;
  }

  return {
    hasAmount: true,
    fee,
    feeLabel: feeConfig?.label ?? "Taxa do meio",
    feePercent: feeConfig?.type === "percent" ? feeConfig.amount : null,
    netCredit: Math.max(0, numericAmount - fee),
  };
};

export const getTransferQuote = ({ currencyId, methodId, amount }) => {
  const feeConfig = TRANSFER_METHOD_FEES[methodId];
  const numericAmount = Number(amount) || 0;
  const hasAmount = numericAmount > 0 && Boolean(methodId);

  if (!hasAmount) {
    return {
      hasAmount: false,
      fee: 0,
      feeLabel: feeConfig?.label ?? "Taxa do meio",
      feePercent: feeConfig?.type === "percent" ? feeConfig.amount : null,
      totalDebit: 0,
    };
  }

  let fee = 0;
  if (feeConfig) {
    fee =
      feeConfig.type === "percent"
        ? numericAmount * (feeConfig.amount / 100)
        : feeConfig.amount;
  }

  return {
    hasAmount: true,
    fee,
    feeLabel: feeConfig?.label ?? "Taxa do meio",
    feePercent: feeConfig?.type === "percent" ? feeConfig.amount : null,
    totalDebit: numericAmount + fee,
  };
};

export const getConversionQuote = (fromId, toId, amount) => {
  const from = getCurrency(fromId);
  const to = getCurrency(toId);
  const numericAmount = Number(amount) || 0;
  const iofApplies = fromId === "brl" || toId === "brl";

  if (!from || !to || numericAmount <= 0) {
    return {
      from,
      to,
      rate: getMockFxRate(fromId, toId),
      amount: 0,
      grossReceive: 0,
      fee: 0,
      feePercent: CONVERSION_FEE_PERCENT,
      iof: 0,
      iofPercent: IOF_PERCENT,
      iofApplies,
      netReceive: 0,
      hasAmount: false,
    };
  }

  let effectiveAmount = numericAmount;
  let iof = 0;

  if (fromId === "brl") {
    iof = numericAmount * (IOF_PERCENT / 100);
    effectiveAmount = numericAmount - iof;
  }

  const rate = getMockFxRate(fromId, toId);
  const grossReceive = effectiveAmount * rate;
  const fee = grossReceive * (CONVERSION_FEE_PERCENT / 100);
  let netReceive = grossReceive - fee;

  if (toId === "brl") {
    iof = grossReceive * (IOF_PERCENT / 100);
    netReceive -= iof;
  }

  return {
    from,
    to,
    rate,
    amount: numericAmount,
    grossReceive,
    fee,
    feePercent: CONVERSION_FEE_PERCENT,
    iof,
    iofPercent: IOF_PERCENT,
    iofApplies,
    netReceive,
    hasAmount: true,
  };
};

export const jitterQuoteRate = (baseRate) => {
  const variation = (Math.random() - 0.5) * 0.002;
  return Math.max(baseRate + baseRate * variation, 0.0001);
};

export const buildLiveQuotes = () =>
  BASE_FX_QUOTES.map((quote) => ({
    ...quote,
    price: formatFxRate(jitterQuoteRate(quote.baseRate)),
  }));
